import * as React from 'react';
import * as styles from './styles.css';

import { identity } from 'ramda';
import { Spinner } from '@cian/ui-kit';

import { ResultReportDescription } from './components';
import { IMarketPriceProps } from './types';
import { ObjectInfoContainer } from '../../containers/ObjectInfoContainer';

export const _MarketPrice: React.ForwardRefRenderFunction<HTMLDivElement, IMarketPriceProps> = (props, ref) => {
  const { isFetching, isReportResultDescriptionVisible, preciseFilters, priceAverage, isDesktop } = props;

  return (
    <div>
      <div ref={ref} className={styles['container']} data-testid="market_price">
        {isDesktop && <ObjectInfoContainer refWrapper={identity} />}
        <div className={styles['result']}>
          {isFetching && (
            <div className={styles['preloader']} data-testid="market_price_preloader_overlay">
              <Spinner size={32} color="icon-main-default" />
            </div>
          )}
          <div className={styles['description']}>{priceAverage}</div>
        </div>

        {isReportResultDescriptionVisible && (
          <div className={styles['result-report-description']}>
            <ResultReportDescription />
          </div>
        )}

        {preciseFilters}
      </div>
    </div>
  );
};

_MarketPrice.displayName = 'MarketPrice';

export const MarketPrice = React.forwardRef(_MarketPrice);
